<template>
	<router-view></router-view>
</template>

<style module>
@import"https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600&family=Alex+Brush&display=swap";.content-box .content-box-header {
	display: flex;
	justify-content: space-between
}

*{
	padding: 0;
	margin: 0;
}

/* html {
	line-height: 1.5;
	-webkit-text-size-adjust: 100%;
	-moz-tab-size: 4;
	-o-tab-size: 4;
	tab-size: 4;
	font-family: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";
	font-feature-settings: normal;
	font-variation-settings: normal;
	white-space: nowrap;
} */

/* li{
	list-style: none;
} */

#loader {
	text-align: center;
	position: fixed;
	z-index: 3;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	opacity: 0;
	visibility: hidden;
	-webkit-transition: all 0.3s ease;
	transition: all 0.3s ease;
	background-color: rgba(255, 255, 255, 0.95);
}

#loader {
	opacity: 1;
	visibility: visible;
}

#loader div {
	display: inline-block;
	width: 50px;
	height: 50px;
	vertical-align: middle;
	-webkit-border-radius: 3px;
	border-radius: 3px;
	background-color: #fff;
	-webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
	box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
}

#loader div:before {
	content: '';
	width: 26px;
	height: 26px;
	display: block;
	margin: 8px auto 0;
	-webkit-border-radius: 20px;
	border-radius: 20px;
	-webkit-animation: loading 1.0s linear forwards infinite;
	animation: loading 1.0s linear forwards infinite;
	border-top: 4px solid #e0f2fe;
	border-right: 4px solid #f87171;
	border-bottom: 4px solid #ffa900;
	border-left: 4px solid #fef3c7;
}

#loader:after {
	content: '';
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}

@keyframes loading {
	100% {
		transform: rotate(360deg);
	}
}

@-webkit-keyframes loading {
	100% {
		-webkit-transform: rotate(360deg);
	}
}

/*! Copyright (c) 2015 Big Bite Creative | bigbitecreative.com | @bigbitecreative */
@import "https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600";
html {
	font-family: sans-serif;
	-ms-text-size-adjust: 100%;
	-webkit-text-size-adjust: 100%;
	background-color: #FDFDFE;
}

body {
	margin: 0;
	overflow-x: hidden;
}

article, aside, details, figcaption, figure, footer, header, hgroup, main, nav, section, summary {
	display:block
}

audio, canvas, progress, video {
	display: inline-block;
	vertical-align:baseline
}

audio:not([controls]) {
	display: none;
	height:0
}

[hidden], template {
	display:none
}

abbr[title] {
	border-bottom:1px dotted
}

b, strong {
	font-weight:bold
}

dfn {
	font-style:italic
}

h1 {
	font-size: 2em;
	margin:0.67em 0
}

mark {
	background: #ff0;
	color:#000
}

small {
	font-size:80%
}

sub, sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align:baseline
}

sup {
	top:-0.5em
}

sub {
	bottom:-0.25em
}

img {
	border:0
}

svg:not(:root) {
	overflow:hidden
}

figure {
	margin:1em 40px
}

hr {
	box-sizing: content-box;
	height:0
}

pre {
	overflow:auto
}

code, kbd, pre, samp {
	font-family: monospace, monospace;
	font-size:1em
}

button, input, optgroup, select, textarea {
	color: inherit;
	font: inherit;
	margin:0
}

button {
	overflow:visible
}

button, select {
	text-transform: none
}

button, html input[type="button"], input[type="reset"], input[type="submit"] {
	-webkit-appearance: button;
	cursor:pointer
}

button[disabled], html input[disabled] {
	cursor:default
}

button::-moz-focus-inner, input::-moz-focus-inner {
	border: 0;
	padding:0
}

input {
	line-height: normal
}

textarea {
	overflow:auto
}

table {
	border-collapse: collapse;
	border-spacing:0
}

td, th {
	padding:0
}

body, h1, h2, h3, h4, h5, h6, p, blockquote, pre, dl, dd, ol, ul, form, fieldset, legend, table, th, td, caption, hr {
	margin: 0;
	padding:0
}

ul, ol, dd {
	margin-left:48px
}

* {
	box-sizing:border-box
}

a {
	text-decoration: none;
}
</style>